<template>
    <div id="print" class="course_main" :style="backgroundDiv">
        <div class="back_nav" @click="goBack"><img src="../../assets/back_nav.png"/></div>
        <div class="score_content" style="top: 20px;right: 30px;" v-if="totalStarCount > 0">
            <img src="../../assets/star_score_s.png"/><span>{{totalStarCount}}</span>
        </div>
        <audio v-show="false" @ended="playEnded()" @error="playEnded" id="musicMp3" controls=""></audio>
        <audio v-show="false" :src="greatAudioUrl" id="great_audio"/>

        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <div class="div_icon">
                        <img id="success_icon" style="display: none" class="icon" src="@/Images/jili.png"/>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="dialogueClick">
                            <span>对话跟读</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="prepare_page" v-show="isPreparePage">
            <div class="navigation_title">亲子对话</div>
            <div class="entry">
                <div class="prepare_entry" @click="prepareClick">
                    <div class="entry_img"><img src="@/Images/icon_prepare_entry.png" alt=""/></div>
                    <div class="entry_text">预习场景</div>
                </div>
                <div class="dialogue_entry" @click="dialogueClick">
                    <div class="entry_img"><img src="@/Images/icon_dialogue_entry.png" alt=""/></div>
                    <div class="entry_text">进入对话</div>
                </div>
            </div>
        </div>

        <div v-show="!isPreparePage" class="scene_des" v-if="!isEmpty(listRecord)">{{listRecord[playIndex].description}}</div>

        <!-- 对话内容 -->
        <div id="record_result" class="dialogue_data" v-show="!isPreparePage">
            <div :id="'qa_index_' + index" v-for="(itemQa,index) in listRecord" :key="index">
                <div class="question" v-if="itemQa.isQuestion === 1">
                    <img src="@/Images/icon_question.png" alt="" />
                    <div class="sanjiao_right"></div>
                    <div class="content" @click="playAudio(index, itemQa.questionAudio)"><div class="word_content">{{itemQa.question}}</div>
                        <div :id="genePlayQaId(index)" class="dialogue_playing img_play" style="display: none"></div>
                        <img :id="geneQaId(index)" class="img_play" src="@/Images/audio_icon_play3.png" />
                    </div>
                </div>
                <div class="answer" v-else>
                    <div class="content" @click="playAudio(index, itemQa.answerAudio)"><div class="word_content">{{itemQa.answer}}</div>
                        <div :id="genePlayQaId(index)" class="dialogue_playing img_play" style="display: none"></div>
                        <img :id="geneQaId(index)" class="img_play" src="@/Images/audio_icon_play3.png" />
                    </div>
                    <div class="sanjiao_left"></div>
                    <img src="@/Images/icon_answer.png" alt="" />
                </div>
            </div>
            <div class="bottom_space"></div>
        </div>

    </div>
</template>

<script>
    import $ from "jquery";
    import Vue from "vue";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                isPreparePage: true,
                listRecord: [],
                audioUrl: '',
                totalCount: 0,
                playIndex: 0,
                showTransition: false,
                greatAudioUrl:"https://img.xiaohuasheng.cn/great.mp3",
                totalStarCount: 0,
                fromPage: 0,
                backgroundDiv:{
                    backgroundImage:'url(' + require('../../assets/qinzi_bg.jpg') + ')',
                    backgroundRepeat:'no-repeat',
                    backgroundSize:'auto 100%',
                    "background-position": "center 0"}
            }
        },
        methods: {
            goBack() {
                let that = this;

                if (!that.isPreparePage) {
                    that.isPreparePage = true;

                    // 停止音频播放
                    var musicMp3 = document.getElementById('musicMp3');
                    musicMp3.pause();
                } else {
                    this.$router.go(-1);
                }
            },
            gameQuitClick() {
                this.$router.go(this.fromPage === 1 ? -2 : -1);
            },
            prepareClick() {
                let that = this;
                that.isPreparePage = false;
                $("#record_result").show();
                let vQa;

                if (!that.isEmpty(that.listRecord)) {
                    vQa = that.listRecord[0];
                }

                setTimeout(() => {
                    if (!that.isEmpty(vQa)) {
                        that.playAudio(0, vQa.isQuestion === 1 ? vQa.questionAudio : vQa.answerAudio);
                    }
                }, 100);
            },
            dialogueClick() {
                this.$router.replace({name: "PDialogue", query: {lessonId: this.lessonId, fromPage:this.fromPage}})
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            showStatusWhite:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (that.isAppAndroid()) {
                    window.note.changeStatusStyle(status);
                }
            },
            geneQaId: function(index) {
                return "qa_" + index;
            },
            genePlayQaId: function(index) {
                return "qa_play_" + index;
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            playAudio: function (index, qaAudioUrl) {
                let that = this;
                if (that.isEmpty(qaAudioUrl)) {
                    return;
                }

                that.playIndex = index;

                that.preId = that.currentId;
                that.prePlayId = that.currentPlayId;

                let vQaId = that.geneQaId(index);
                let vPlayId = that.genePlayQaId(index);
                that.currentId = vQaId;
                that.currentPlayId = vPlayId;

                if (!that.isEmpty(that.preId)) {
                    // 显示
                    $("#" + that.preId).show();
                }

                if (!that.isEmpty(that.prePlayId)) {
                    // 隐藏
                    $("#" + that.prePlayId).hide();
                }

                if (!that.isEmpty(that.currentId)) {
                    // 隐藏
                    $("#" + that.currentId).hide();
                }

                if (!that.isEmpty(that.currentPlayId)) {
                    // 显示
                    $("#" + that.currentPlayId).show();
                }

                // that.audioUrl = that.$qiNiuDomainBase + qaAudioUrl;
                const musicMp3 = document.getElementById('musicMp3');
                musicMp3.src = that.$qiNiuDomainBase + qaAudioUrl;
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError !== "{}") {
                            window.console.log("播放失败:playAudio:" + vError);
                        }
                    });
                } else {
                    window.console.log("播放失败:playAudio");
                }
            },
            playEnded: function () {
                let that = this;
                if (!that.isEmpty(that.currentId)) {
                    // 隐藏
                    $("#" + that.currentId).show();
                }

                if (!that.isEmpty(that.currentPlayId)) {
                    // 显示
                    $("#" + that.currentPlayId).hide();
                }

                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();

                let vPlatform = that.judgePlatform();

                if (that.playIndex < that.listRecord.length - 1) {
                    that.playIndex += 1;
                    let vQa = that.listRecord[that.playIndex];

                    if (that.playIndex === that.listRecord.length - 1) {
                        setTimeout(() => {
                            var container = document.getElementById("record_result");
                            container.scrollTop = container.scrollHeight;
                        }, 100);
                    } else {
                        setTimeout(() => {
                            let vQaIndex = vPlatform === 3 ? that.playIndex : that.playIndex + 1;
                            document.getElementById("qa_index_" + vQaIndex).scrollIntoView({
                                behavior: "smooth",
                                block: "end"
                            });
                        }, 100);
                    }

                    setTimeout(() => {
                        that.playAudio(that.playIndex, vQa.isQuestion === 1 ? vQa.questionAudio : vQa.answerAudio);
                    }, 200);
                } else {
                    // 最后一题
                    that.showTransition = true;

                    setTimeout(function () {
                        const greatAudio = document.getElementById('great_audio');
                        greatAudio.play();
                        $("#success_icon").show(800, function(){});
                    }, 100);
                }
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(this.$route.query.lessonId);
            let vFromPage = parseInt(that.$route.query.fromPage);
            let url = "englishProgram/getDialog/" + vLessonId;

            this.$axios.get(url).then((response) => {
                that.lessonId = vLessonId;
                that.fromPage = vFromPage;
                let listDialogue = response.data;

                let vCount = 0;
                listDialogue.forEach((dialogue) => {
                    if (that.totalStarCount === 0) {
                        that.totalStarCount = dialogue.totalStarCount;
                    }

                    dialogue.qaList.forEach((item) => {
                        item.description = dialogue.description;
                        Vue.set(that.listRecord, vCount, item);
                        vCount += 1;
                    });
                });

                that.totalCount = vCount;
                that.hideStatusAndStopAudio();

                setTimeout(() => {
                    transformView();
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhite(0);
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatusWhite(1);
            next();
        },
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .course_main {
        width: 100%;
        height: 100%;
    }

    .prepare_page {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
    .prepare_page .navigation_title {
        width: 100%;
        height: 66px;
        text-align: center;
        line-height: 66px;
        font-size: 18px;
        color: white;
    }
    .entry {
        position: absolute;
        left: 0;
        top: 66px;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .entry .prepare_entry {
        width: 120px;
        height: 110px;
        background-color: #f4b940;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .entry .dialogue_entry {
        width: 120px;
        height: 110px;
        background-color: #62a531;
        margin-left: 60px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .entry_img img {
        width: 60px;
        height: 60px;
        margin-left: 30px;
        margin-top: 10px;
    }
    .entry_text {
        width: 120px;
        text-align: center;
        font-size: 15px;
        color: white;
    }

    .dialogue_data {
        width: 80vmax;
        height: calc(100vmin - 100px);
        position: absolute;
        left: 50%;
        top: 80px;
        -webkit-transform: translateX(-50%);
        overflow-x: hidden;
        overflow-y: scroll;
        font-size: 16px;
        font-weight: bold;
        font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI", "Microsoft YaHei", "微软雅黑", sans-serif;
    }

    .dialogue_data .question {
        display: inline-flex;
        margin-top: 15px;
    }
    .dialogue_data .question img {
        width: 35px;
        height: 35px;
        margin-top: 7.5px;
    }
    .dialogue_data .question .content {
        width: calc(80vmax - 105px);
        min-height: 50px;
        background-color: #ffe2d6;
        display: inline-flex;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .dialogue_data .question .content .word_content {
        width: calc(80vmax - 135px);
        padding: 15px 10px;
        word-wrap: break-word;
        overflow: hidden;
    }
    .dialogue_data .question .content .img_play {
        width: 20px;
        height: 20px;
        margin-left: 0;
        margin-right: 10px;
        margin-top: 15px;
    }

    .dialogue_data .answer {
        display: inline-flex;
        margin-top: 15px;
    }
    .dialogue_data .answer .content {
        width: calc(80vmax - 105px);
        min-height: 50px;
        background-color: #95cdf7;
        display: inline-flex;
        margin-left: 55px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .dialogue_data .answer .content .word_content {
        width: calc(80vmax - 135px);
        padding: 15px 10px;
        word-wrap: break-word;
        overflow: hidden;
    }
    .dialogue_data .answer .content .img_play {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        margin-top: 15px;
    }
    .dialogue_data .answer img {
        width: 35px;
        height: 35px;
        margin-right: 20px;
        margin-top: 7.5px;
    }

    .bottom_space {
        height: 20px;
    }
    .sanjiao_left {
        width: 0;
        height: 0;
        overflow: hidden;
        border-width: 10px;
        margin-top: 15px;
        border-color: transparent transparent transparent #95cdf7;
        border-style: dashed dashed dashed solid;
    }

    .sanjiao_right {
        width: 0;
        height: 0;
        overflow: hidden;
        border-width: 10px;
        margin-top: 15px;
        border-color: transparent #ffe2d6 transparent transparent;
        border-style: dashed solid dashed dashed;
    }

    @keyframes zoom {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }

    @keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    @-webkit-keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }
    .scene_des {
        position: absolute;
        top: 20px;
        left: 18vmax;
        right: 18vmax;
        text-align: center;
        font-size: 15px;
        color: white;
        display: inline-block;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 15px;
        padding-right: 15px;
        background-color: rgba(0,0,0,0.4);
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .content2 {
        text-align: center;
    }

    .transition .content3 {
        text-align: center;
    }
    .transition .content .div_icon {
        margin-bottom: 10px;
        width: 100%;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .transition .content .div_icon .icon {
        width: 206px;
        height: 136px;
    }
    .transition .content .text {
        width: 100%;
    }
    .transition .content .text span {
        display: block;
        text-align: center;
    }
    .transition .content .text .success_tip {
        font-size: 20px;
    }
    .transition .content .star {
        height: 35px;
    }
    .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }

</style>
